export default {
  NODE_ENV: 'production',
  ENDPOINTS: {
    CAT4MRO: 'https://cat4mro.herokuapp.com/v1/graphql',
  },
  IDENTITY: {
    AUTHORITY: 'https://sts.ulinksolution.com',
    REDIRECT_URI: 'https://portal.cat4mro.com/static/callback.html',
    SILENT_REDIRECT_URI: 'https://portal.cat4mro.com/static/silent-renew.html',
    POST_LOGOUT_REDIRECT_URI: 'https://portal.cat4mro.com',
  },
  ApplicationInsightsKey: 'bee33c28-b2af-4987-97b5-26f779d216a1',
};



// WEBPACK FOOTER //
// ./src/config/env.production.js